import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import type { IFacilityGroup, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getFacilityGroups = async (
  params?: DataQueryParams,
): Promise<IPage<IFacilityGroup>> =>
  await getRequest(API_BASE_PATHS.FACILITY_GROUPS, formatQueryParams(params));

export const addFacilityGroup = async (body: any) =>
  await postRequest(API_BASE_PATHS.FACILITY_GROUPS, {}, body);

export const updateFacilityGroup = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.FACILITY_GROUPS}/${id}`, {}, body);

export const deleteFacilityGroup = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.FACILITY_GROUPS}/${id}`);
